import React from "react";
import { Box } from '@mui/material';
import '../pages/Home.css';
import QuestionAnswer from "./QuestionAnswer";

const questions = [
  {
    "question": "What is this experience? ",
    "answer": "This is a Universal Epic Universe Grand Opening Day Digital Medallion experience. Guests can redeem one (1) Universal Epic Universe digital medallion via their ticket insert. This digital medallion allows guests to keep a commemorative achievement for being part of this special day."
  },
  {
    "question": "What happens to my digital collectible collection if I delete my NBCUniversal Profile?",
    "answer": "By deleting your NBCUniversal Profile, you will lose access to your digital collectible collection and digital wallet. If you would like to maintain access to your digital collectible collection, please contact support@backlotclub.com prior to deleting your NBCUniversal Profile."
  },  {
    "question": "Is there an age requirement for this experience?",
    "answer": "Yes. You must at least eighteen (18) years old to redeem the Universal Epic Universe Digital Medallion."
  },
  {
    "question": "What operating systems does the Universal Medallion App work on?",
    "answer": "The app and collectibles work on iOS and Android operating systems."
  },
  {
    "question": "How do I redeem my digital collectible?",
    "answer": "Redeem your digital collectible by entering the unique passcode provided on the insert."
  },
  {
    "question": "Do I have to attend Epic Universe Grand Opening to redeem the collectible?",
    "answer": "Yes. You will need to have a valid event admission to Universal Epic Grand Opening to attend the event and have the option to redeem the collectible."
  },
  {
    "question": "What is an NFT?",
    "answer": "An NFT, or non-fungible token, is a digital asset that certifies ownership and authenticity of a digital or physical asset and is recorded on a blockchain."
  },
  {
    "question": "How do I see my NFTs?",
    "answer": "When you collect your first NFT, you will be prompted to create a digital wallet to store and access it."
  },
  {
    "question": "Can I resell my Universal Digital Medallions NFT on an open marketplace?",
    "answer": "No, you cannot sell your Universal Digital Medallions NFT at this time."
  },
  {
    "question": "What blockchain is this NFT minted on?",
    "answer": "We use Aptos blockchain, an energy-efficient platform, for our transactions."
  },
  {
    "question": "I have a web3 wallet. How do I see my Universal Digital Medallions NFT there?",
    "answer": "If you have a 3rd party wallet application like Petra and would like to bring your digital card NFTS there, contact support@backlotclub.com."
  },
  {
    "question": "Who can I contact for technical issues?",
    "answer": "Please contact support@backlotclub.com for assistance."
  },
  {
    "question": "Can I transfer my digital collectible to someone else?",
    "answer": "No. Digital collectibles are unique to your profile. They are non-transferrable."
  },
  {
    "question": "What is a public digital wallet?",
    "answer": "It is a “wallet” that exist on a blockchain that allows users to store and manage their digital assets (for example, NFTs). Blockchain wallets contain what are called public and private keys. The public key will allow NBCUniversal to transfer the Universal Epic Universe Digital Medallion NFT to your wallet via the blockchain. The private key is a confidential code used for accessing your digital assets. When your digital wallet is created, access will be securely managed via your NBCUniversal Profile log in and password, but your private key can be provided upon request to support@backlotclub.com."
  },
  {
    "question": "How can I delete Aptos wallet?",
    "answer": "By deleting your Aptos wallet, you will lose all access to your UNIVERSAL EPIC UNIVERSE DIGITAL MEDALLION NFT and any other tokens you may have in that wallet. If you are sure you want to proceed, please email support@backlotclub.com."
  },
  {
    "question": "What can I do with the collectible once I have redeemed it?",
    "answer": "You'll have major bragging rights, so go for it! Hold on to your account info and collectibles for potential future opportunities."
  },
  {
    "question": "I need help redeeming my UNIVERSAL EPIC UNIVERSE GRAND OPENING DAY MEDALLION NFT.",
    "answer": "Please contact support@backlotclub.com."
  },
  {
    "question": "How can I delete my Aptos Wallet?",
    "answer": "By deleting your Aptos wallet, you will lose all access to your UNIVERSAL EPIC UNIVERSE GRAND OPENING DAY MEDALLION NFT and any other tokens you may have in that wallet. If you are sure you want to proceed, please email support@backlotclub.com."
  },
  {
    "question": "What happens to my digital collectible collection if I delete my NBCUniversal Profile?",
    "answer": "By deleting your NBCUniversal Profile, you will lose access to your digital collectible collection and digital wallet. If you would like to maintain access to your digital collectible collection, please contact support@backlotclub.com prior to deleting your NBCUniversal Profile."
  },
  {
    "question": "What operating systems does the Universal Epic Universe Grand Opening Day Medallion App work on?",
    "answer": "The app and collectibles work on iOS and Android operating systems."
  },
  {
    "question": "How do I redeem my digital collectibles?",
    "answer": "Redeem your digital collectible by entering the unique passcode provided on the insert."
  },
  {
    "question": "I need help redeeming my UNIVERSAL EPIC UNIVERSE GRAND OPENING DAY MEDALLION NFT.",
    "answer": "Please contact support@backlotclub.com"
  },
  {
    "question": "How can I delete my Aptos Wallet?",
    "answer": "By deleting your Aptos wallet, you will lose all access to your UNIVERSAL EPIC UNIVERSE GRAND OPENING DAY MEDALLION NFT and any other tokens you may have in that wallet. If you are sure you want to proceed, please email support@backlotclub.com."
  }
];

const FAQ: React.FC = () => {

  return (
    <Box>
      <div style={{
        width: '90%',
        maxWidth: '600px',
        margin: '0 auto',
        display: 'block'
      }}>
        <p style={{
          position: 'relative',
          fontSize: 28, // Reduced from 36px
          color: '#cccccc', // Lighter color
          fontWeight: 600,
          marginTop: 20, // Reduced top margin
          marginBottom: 8, // Reduced bottom margin
          textShadow: '1px 1px 5px #000000', // Reduced shadow
        }}>FAQ</p>
        {questions.map((qa, i) => {
          return <QuestionAnswer key={i} question={questions[i]['question']} answer={questions[i]['answer']} />
        })}
      </div>
    </Box>
  );
};

export default FAQ;